<template>
    <div class="dt__wrapper-wrapper">
        <div class="dt__wrapper">
            <table class="dt">
                <thead>
                <tr class="dt__header">
                    <th class="dt__img-header"></th>
                    <th class="dt__carat-header">{{ $t('components.carat') }}</th>
                    <th class="dt__cut-header">{{ $t('components.cut') }}</th>
                    <th class="dt__clarity-header">{{ $t('components.clarity') }}</th>
                    <th class="dt__color-header">{{ $t('components.color') }}</th>
                    <th class="dt__price-header">{{ $t('components.price') }}</th>
                </tr>
                </thead>
                <tbody>
                <diamond-table-entry
                    v-for="diamond in sortedDiamonds"
                    :key="diamond.id"
                    :diamond="diamond"
                    :active="diamond.id === selectedDiamond?.id"
                    @click="handleSelectDiamond(diamond)"
                />
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import {computed, defineComponent} from "vue";
import useStore from "@/composables/useStore";
import {Diamond} from "@/api/Diamond";
import DiamondTableEntry from "@/components/DiamondTableEntry.vue";

export default defineComponent({
    name: "DiamondTable",
    components: {
        DiamondTableEntry
    },
    setup() {
        const {
            actions: {setDiamond},
            computed: {filteredDiamonds, selectedDiamond}
        } = useStore();

        const hasDiamonds = computed(() => filteredDiamonds.value.length > 0);

        const sortedDiamonds = computed(() =>
            filteredDiamonds.value.sort((a, b) => a.price - b.price)
        );

        function handleSelectDiamond(diamond: Diamond) {
            setDiamond(diamond);
        }

        return {
            filteredDiamonds,
            hasDiamonds,
            handleSelectDiamond,
            selectedDiamond,
            sortedDiamonds
        };
    }
});
</script>

<style>
.dt__wrapper-wrapper {
    padding-bottom: 1rem;
    border-bottom: 0.5px solid #8A8989;
}

.dt__wrapper {
    margin-right: -16px;
    padding-right: 16px;
    max-height: 400px;
    overflow-y: scroll;
}

.dt {
    display: table;
    border-collapse: collapse;
    width: 100%;
    border-radius: 3px;
}

.dt__header {
    width: 100%;
    position: sticky;
    top: -2px;
    background: white;
    border-bottom: 0.5px solid #8A8989;
}

.dt__header th {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #111111;
    padding: 1rem 0.5rem;
}

.dt__row {
    width: 100%;
    cursor: pointer;
    transition: font-weight;
    white-space: nowrap;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #BBBBBB;
}

.dt__row:hover {
    color: #111111;
}

.dt__row--active {
    font-style: normal;
    text-align: center;
    color: #111111;
}

.dt__row:first-child td {
    padding: 1rem 0.5rem 0.5rem 0.5rem;
}

.dt__row:first-child td:first-child {
    padding-left: 0;
}

.dt__row:first-child td:last-child {
    padding-right: 0;
}

.dt__img-header,
.dt__img-row {
    width: 14px;
    max-width: 14px;
    padding: 0.5rem 0.5rem 0.5rem 0;
}

.dt__carat-header,
.dt__carat-row {
    text-align: right;
    padding: 0.5rem;
}

.dt__cut-header,
.dt__cut-row {
    text-align: center;
    padding: 0.5rem;
}

.dt__clarity-header,
.dt__clarity-row {
    text-align: center;
    padding: 0.5rem;
}

.dt__color-header,
.dt__color-row {
    text-align: center;
    padding: 0.5rem;
}

.dt__price-header,
.dt__price-row {
    text-align: right;
    padding: 0.5rem 0 0.5rem 0.5rem;
}

.dt__img-row img {
    width: 14px;
    max-width: 14px;
}

.dt__price-row {
    font-weight: normal;
}
</style>
